import { render, staticRenderFns } from "./z_news.vue?vue&type=template&id=ae2f5438&scoped=true&"
import script from "./z_news.vue?vue&type=script&lang=js&"
export * from "./z_news.vue?vue&type=script&lang=js&"
import style0 from "./z_news.vue?vue&type=style&index=0&id=ae2f5438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2f5438",
  null
  
)

export default component.exports